import { render, staticRenderFns } from "./FactorTransactionActionColumn.vue?vue&type=template&id=37f85a51&scoped=true&"
import script from "./FactorTransactionActionColumn.vue?vue&type=script&lang=js&"
export * from "./FactorTransactionActionColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f85a51",
  null
  
)

export default component.exports